import React from "react";

export default function FileInput({data, changeHandler}) {
    return (
        <div className={`hq-form__field hq--form__field--default`}>
            {data.label ? <label className="hq-form__label" htmlFor={data.id}>{data.label}{data.isRequired ? <span>*</span> : ''}</label> : null}
            <input className="hq-form__field--input" accept={`${data.allowedExtensions}`} placeholder={data.placeholder ? data.placeholder : null} type={'file'} id={data.id} required={data.isRequired ? 'required' : ''} onChange={(e)=>{changeHandler(e, data.id, data.type)}}></input>
        </div>
    )
}